import { IconButton } from '@mui/material'
import React from 'react'
import { J1RightarrowD } from '@e3dc-react/icons'

import { makeStyles } from 'tss-react/mui'
import { useNavigate } from 'react-router-dom'

const useStyles = makeStyles()(theme => ({
  iconStyle: {
    color: theme.palette.text.primary,
    display: 'none',
    width: '36px',
    height: '36px',
    [theme.breakpoints.up('sm')]: { display: 'block' },
  },
}))

interface Props {
  link?: string
}

/**
 * Right Arrow Button to navigate to a link
 */
const RightArrowButton: React.FC<Props> = ({ link }) => {
  const { classes } = useStyles()
  const navigate = useNavigate()

  const handleNavigate = (event: React.MouseEvent<HTMLButtonElement>): void => {
    if (!link) return
    event.preventDefault()
    navigate(link)
  }

  return (
    <IconButton className={classes.iconStyle} onClick={handleNavigate}>
      <J1RightarrowD />
    </IconButton>
  )
}

export default RightArrowButton
